import request from '@/utils/request'

//首页左侧实时数据
export function adaption(data) {
  return request({
    url: "/statistic/settings/home/page/adaption",
    method: "post",
    data: data,
  });
}

//首页-订单中心 今日订单数量统计
export function saleTodayCount(params) {
  return request({
    url: "/order/order/sys/sale/todayCount",
    method: "get",
    params,
  });
}

//首页-订单中心 今日售后数量统计
export function afterSaleTodayCount(params) {
  return request({
    url: "/order/aftersale/platform/todayCount",
    method: "get",
    params,
  });
}
